import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "dropdown", "list"]
  static values = {
    foldersUrl: String
  }

  connect() {
    this.folders = []
    this.loadFolders()

    // Close dropdown when clicking outside
    document.addEventListener("click", this.closeDropdown.bind(this))
  }

  disconnect() {
    document.removeEventListener("click", this.closeDropdown.bind(this))
  }

  async loadFolders() {
    try {
      const response = await fetch(this.foldersUrlValue)
      if (!response.ok) throw new Error("Failed to load folders")

      const data = await response.json()
      this.folders = data.folders.map(folder => folder.path)
    } catch (error) {
      console.error("Error loading folders:", error)
      this.folders = []
    }
  }

  showDropdown(event) {
    event.stopPropagation()
    this.filterFolders()
    this.dropdownTarget.classList.remove("hidden")
  }

  closeDropdown(event) {
    if (event && this.element.contains(event.target)) {
      return
    }
    if (this.hasDropdownTarget) {
      this.dropdownTarget.classList.add("hidden")
    }
  }

  filterFolders() {
    const query = this.inputTarget.value.toLowerCase().trim()

    // Filter folders that match the query
    const matchingFolders = this.folders.filter(folder =>
      folder.toLowerCase().includes(query)
    )

    // If no query, show all folders
    const foldersToShow = query === "" ? this.folders : matchingFolders

    // Render dropdown
    if (foldersToShow.length === 0) {
      this.listTarget.innerHTML = `
        <div class="px-4 py-3 text-sm text-gray-500 text-center">
          No folders found
        </div>
      `
    } else {
      this.listTarget.innerHTML = foldersToShow.map(folder => `
        <button type="button"
                data-action="click->folder-selector#selectFolder"
                data-folder-path="${folder}"
                class="w-full flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 text-left">
          <i class="fas fa-folder text-yellow-500 flex-shrink-0"></i>
          <span class="flex-1 truncate">${folder}</span>
        </button>
      `).join("")
    }
  }

  selectFolder(event) {
    event.preventDefault()
    event.stopPropagation()

    const folderPath = event.currentTarget.dataset.folderPath
    this.inputTarget.value = folderPath
    this.closeDropdown()

    // Trigger change event so form knows field was updated
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
